import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { getFormValues } from 'redux-form';

import { TRANSACTION_FORM_NAME } from 'Common/FormEnum';
import * as QueueActions from 'PointOfSale/modules/queue/state/actions';
import * as TeacherActions from 'PointOfSale/modules/teacher/state/actions';
import * as MealTypesActions from 'PointOfSale/modules/mealTypes/state/actions';
import * as IndividualServingActions from 'PointOfSale/modules/individualServing/state/actions';
import * as MealCounterActions from 'PointOfSale/modules/cepCard/state/actions';
import ServingFoodItemsComponent from 'PointOfSale/modules/individualServing/component/ServingFoodItems';
import * as POSSelectors from 'PointOfSale/selectors';
import { getValue } from 'Common/Components/Keyboard/withKeyboard';
import { InputDialog } from 'Components';
import { LAYOUT_TYPES } from 'Common/Components/Keyboard/constants';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';

class ServingFoodItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      item: null,
      isItemQuanityModalOpen: false,
      searchText: '',
    };
  }

  tabClickHandler = tab => {
    this.props.onItemCategoryClick(tab);
  };

  searchHandler = e => {
    const searchText = getValue(e);
    this.setState({ searchText });
  };

  addItem = (item, quantity, setQuantity = false) => {
    const { transactionFormValues, IndividualServingActions } = this.props;

    if (transactionFormValues.StudentIdSeed) {
      IndividualServingActions.addItem(item, quantity, setQuantity);
    }
  };

  onItemClick = item => {
    const { profile } = this.props.currentProfile;

    profile.StatusCurrent === '5'
      ? this.props.setNotificationDialog(
          NOTIFICATION_DIALOG_MESSAGES.WITHDRAWN_STUDENT_SERVE_ATTEMPT
        )
      : this.addItem(item, 1);
  };

  onItemLongPress = item => {
    this.setState({
      item,
      isItemQuanityModalOpen: true,
    });
  };

  onEditClick = () => {
    const isModalOpen = this.state.isModalOpen;
    this.props.MealTypesActions.selectTabMenu({ key: 'All Food Items' });
    this.setState({
      isModalOpen: !isModalOpen,
    });
  };

  getItemForDialog = () => {
    const { additionalItems } = this.props;
    const { item } = this.state;
    const foundItem = additionalItems.find(ai => ai.ItemId === item.ItemId);
    return foundItem;
  };

  /** Used to set the quantity of the input to match the item's current quantity */
  getInitialAmount = () => {
    const foundItem = this.getItemForDialog();
    return foundItem ? String(foundItem.Qty) : '1';
  };

  getOkText = () => {
    const foundItem = this.getItemForDialog();
    return foundItem ? 'Update' : 'Add';
  };

  render() {
    const {
      foodItems,
      additionalItems,
      currentSelectedMenu,
      sessions,
      activeSession,
      tabMenus,
      currentSelectedTabMenu,
      nutritionCodes,
      itemCategories,
      servedItemsOrder,
    } = this.props;

    const {
      item,
      isItemQuanityModalOpen,
      isModalOpen,
      searchText,
    } = this.state;

    return (
      <React.Fragment>
        <ServingFoodItemsComponent
          tabMenus={tabMenus}
          tabClickHandler={this.tabClickHandler}
          searchText={searchText}
          additionalItems={additionalItems}
          currentSelectedFoodItems={_.get(foodItems, [
            currentSelectedMenu,
            currentSelectedTabMenu,
          ])}
          sessions={sessions}
          activeSession={activeSession}
          onItemClick={this.onItemClick}
          onItemLongPress={this.onItemLongPress}
          searchHandler={this.searchHandler}
          isModalOpen={isModalOpen}
          onEditClick={this.onEditClick}
          onModalToggle={this.onEditClick}
          nutritionCodes={nutritionCodes}
          itemCategories={itemCategories}
          servedItemsOrder={servedItemsOrder}
        />
        {isItemQuanityModalOpen && (
          <InputDialog
            showDialog={isItemQuanityModalOpen}
            title={`${item && item.Description}`}
            message="Enter quantity"
            onOkClick={quantity => {
              const qty = parseInt(quantity, 10);
              if (item) {
                this.addItem(item, qty, true);
              }
              this.setState({ isItemQuanityModalOpen: false, item: null });
            }}
            onCancelClick={() => {
              this.setState({ isItemQuanityModalOpen: false, item: null });
            }}
            okText={this.getOkText()}
            maxLength={3}
            type="numeric"
            useKeyboard
            layoutType={LAYOUT_TYPES.NUMERIC}
            focusOnMount
            initialText={this.getInitialAmount()}
          />
        )}
      </React.Fragment>
    );
  }
}

ServingFoodItems.propTypes = {
  mealTypes: PropTypes.object,
  tabMenus: PropTypes.arrayOf(PropTypes.object),
  additionalItems: PropTypes.array,
  onItemClick: PropTypes.func,
  sessions: PropTypes.object,
  activeSession: PropTypes.string,
  currentSelectedMenu: PropTypes.string,
};

const mapStateToProps = state => ({
  servedItemsOrder: POSSelectors.getServedItemsOrder(state),
  foodItems: POSSelectors.filteredAllFoodItems(state),
  additionalItems: POSSelectors.getCurrentTransactionBoughtItems(state),
  currentSelectedMenu: POSSelectors.getCurrentSelectedMenu(state),
  activeSession: POSSelectors.getActiveSession(state),
  sessions: POSSelectors.getSessions(state),
  currentTransaction: POSSelectors.getCurrentTransaction(state),
  transactionFormValues: getFormValues(TRANSACTION_FORM_NAME)(state) || {},
  queue: POSSelectors.getQueue(state),
  autoServe: POSSelectors.getAutoServe(state),
  currentProfile: POSSelectors.getCurrentProfile(state),
  hasMealCounterSession: POSSelectors.hasMealCounterSession(state),
  nutritionCodes: POSSelectors.getNutritionCodes(state),
  itemCategories: POSSelectors.getItemCategories(state),
});

const mapDispatchToProps = dispatch => ({
  TeacherActions: bindActionCreators(TeacherActions, dispatch),
  MealTypesActions: bindActionCreators(MealTypesActions, dispatch),
  IndividualServingActions: bindActionCreators(
    IndividualServingActions,
    dispatch
  ),
  QueueActions: bindActionCreators(QueueActions, dispatch),
  MealCounterActions: bindActionCreators(MealCounterActions, dispatch),
  setNotificationDialog: message => dispatch(setNotificationDialog(message)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ServingFoodItems)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/container/ServingFoodItems.js